import styled from "styled-components/macro";

const Main = styled.div`
    height: 100%;
    padding: 24px;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export default Main;
